export const common = {
  // Navigation
  'nav.features': 'Возможности',
  'nav.howItWorks': 'Как это работает',
  'nav.pricing': 'Цены',
  'nav.faq': 'Часто задаваемые вопросы',
  'nav.aboutUs': 'О нас',
  'nav.getStarted': 'Начать',

  // About Us Section
  'aboutUs.badge': "О нас",
  'aboutUs.title': "Зачем существует IdeaVerdict",
  'aboutUs.line1': "Идея может быть у каждого.",
  'aboutUs.line2': "Мало кто признаёт, что его идея не выдерживает проверки.",
  'aboutUs.paragraph1':
    "Большинство идей проваливаются не из-за нехватки смелости у основателей. Они проваливаются, потому что никто не сказал им правду достаточно рано. IdeaVerdict закрывает этот пробел — мы даём вам жёсткую оценку, которую друзья не дадут.",
  'aboutUs.belief1a': "Мы не торгуем хайпом.",
  'aboutUs.belief1b': "Мы торгуем рыночными сигналами.",
  'aboutUs.belief2a': "Мы не продаём мотивацию.",
  'aboutUs.belief2b': "Мы продаём чёткое прочтение спроса, конкуренции и реализуемости.",
  'aboutUs.mission1': "Наша задача — не сделать вашу идею красивой.",
  'aboutUs.mission2': "Наша задача — сказать, действительно ли она такая.",
  'aboutUs.analysis':
    "IdeaVerdict оценивает идеи по тому, что имеет значение — структура рынка, реальный спрос, конкуренция, требуемый капитал, время до выручки, масштабируемость. Без эмоций. Без оптимизма. Только анализ.",
  'aboutUs.failure1': "Большинство бизнесов проваливаются.",
  'aboutUs.failure2': "Не потому, что люди за ними были некомпетентны —",
  'aboutUs.failure3': "а потому, что никто не возразил достаточно жёстко и достаточно рано.",
  'aboutUs.clarity': "Мы существуем, чтобы возражать.",
  'aboutUs.value1': "Прямо.",
  'aboutUs.value2': "Честно.",
  'aboutUs.value3': "Быстро.",
  'aboutUs.confirm': "Если в вашей идее есть содержание, мы её поддержим.",
  'aboutUs.deny': "Если нет — скажем вам в лицо.",
  'aboutUs.noApplause': "Никаких аплодисментов.",
  'aboutUs.noSugarcoating': "Никаких прикрас.",
  'aboutUs.noTheater': "Никакого театра.",
  'aboutUs.noHype': "Только вердикт.",
  // Hero Section
  'hero.badge': 'ИИ-вердикт менее чем за 60 секунд',
  'hero.title1': 'Не стройте,',
  'hero.title2': 'пока не проверите.',
  'hero.subtitle': 'IdeaVerdict проверяет вашу идею как скептичный VC.',
  'hero.subtitleLine2': 'Честный вердикт за секунды — без хайпа, без лести.',
  'hero.cta': 'Получить вердикт',
  'hero.ctaSecondary': 'Как это работает',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Кредитов за запрос',
  'hero.stat2Value': 'От 7',
  'hero.stat2Label': 'Параметра оценки',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Честно и конфиденциально',

  // Features Section
  'features.title1': 'Создано для',
  'features.title2': 'основателей,',
  'features.title3': 'которым нужна правда',
  'features.bullet1.title': 'Честный вердикт за секунды',
  'features.bullet1.description':
    'Сильный, Смешанный или Слабый — с обоснованием. Без аплодисментов, без прикрас, без театра.',
  'features.bullet2.title': 'Оценка по тому, что действительно важно',
  'features.bullet2.description':
    'Вашу идею оценивают по реальному спросу, конкуренции, необходимому капиталу, времени до выручки и масштабируемости — без эмоций.',
  'features.bullet3.title': 'От вердикта к запуску',
  'features.bullet3.description':
    'Режим Builder превращает одобренную идею в бриф для разработчиков: пользовательские сценарии, ключевые функции, технические заметки.',

  // How It Works
  'howItWorks.title': 'Как это работает',
  'howItWorks.subtitle': 'Четыре шага к ясности о вашей бизнес-нише.',
  'howItWorks.step1Title': 'Выберите тариф',
  'howItWorks.step1Desc': 'Starter, Pro или Builder — в зависимости от глубины анализа.',
  'howItWorks.step2Title': 'Спросите ИИ',
  'howItWorks.step2Desc': 'Задайте вопросы о нише. Каждый запрос стоит 30 кредитов.',
  'howItWorks.step3Title': 'Получите честный вердикт',
  'howItWorks.step3Desc': 'ИИ оценивает: Хорошо, Средне или Плохо. Никаких приукрашиваний.',
  'howItWorks.step4Title': 'Примите решение',
  'howItWorks.step4Desc': 'Теперь вы знаете, стоит ли двигаться дальше.',

  // Pricing
  'pricing.title': 'Цены',
  'pricing.subtitle': 'Выберите тариф, соответствующий глубине вашего анализа.',
  'pricing.monthly': 'Ежемесячно',
  'pricing.yearly': 'Ежегодно',
  'pricing.yearlyDiscount': 'Годовая подписка:',
  'pricing.yearlyDiscountValue': '-20% скидка',
  'pricing.perMonth': 'в месяц',
  'pricing.selectPlan': 'Выбрать тариф',
  'pricing.mostPopular': 'Самый популярный',
  'pricing.footer':
    'Все цены в швейцарских франках. Кредиты списываются только за успешные ответы ИИ.',

  
  // Pricing Features
  'pricing.feature1': 'Бесплатный чат (без формы)',
  'pricing.feature2': 'Рыночная логика и честная оценка',
  'pricing.feature3': 'Постоянная история чатов',
  'pricing.feature4': 'Несколько параллельных чат-сессий',
  'pricing.feature5': 'Полная мультиязычность',
  'pricing.feature6': 'Использование на основе кредитов',
  'pricing.feature7': 'Ежемесячный сброс',
  'pricing.feature8': 'Анализ рынка',
  'pricing.feature9': 'Резюме',
  'pricing.feature10': 'Сильные стороны',
  'pricing.feature11': 'Слабые стороны',
  'pricing.feature12': 'Возможности',
  'pricing.feature13': 'Риски',
  'pricing.feature14': 'Рекомендации',
  'pricing.feature15': 'Скачать PDF',
  'pricing.feature16': 'Без брифингов для разработчиков',
  'pricing.feature17': 'Режим сборщика: Брифинги для разработчиков',
  'pricing.feature18': 'Структурированное резюме',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Доступ к ИИ-чатботу для ниш',
  'pricing.starter.credits': '2500 кредитов в месяц',
  'pricing.starter.feature1': 'Генерация идеи ниши',
  'pricing.starter.feature2': 'Уточнение ниши',
  'pricing.starter.feature3': 'Проверка рыночной реальности',
  'pricing.starter.feature4': 'Оценка конкуренции',
  'pricing.starter.feature5': 'Оценка времени',
  'pricing.starter.feature6': 'Честный вердикт',
  'pricing.starter.feature7': 'Приватные сессии',
  'pricing.starter.feature8': 'История и экспорт',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Доступ к ИИ-чатботу для ниш',
  'pricing.pro.credits': '5000 кредитов в месяц',
  'pricing.pro.feature1': 'Все функции Starter',
  'pricing.pro.feature2': 'Больше кредитов для интенсивного анализа',
  'pricing.pro.feature3': 'Предложения по улучшению',
  'pricing.pro.feature4': 'Альтернативные ниши',
  'pricing.pro.feature5': 'Детальный рыночный анализ',
  'pricing.pro.feature6': 'Приоритетная поддержка',
  'pricing.pro.feature7': 'Расширенные фильтры',
  'pricing.pro.feature8': 'Избранные сессии',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Все функции + режим Builder",
  'pricing.builder.credits': "10 000 кредитов в месяц",
  'pricing.builder.feature1': 'Все функции Pro',
  'pricing.builder.feature2': 'Неограниченные запросы к ИИ',
  'pricing.builder.feature3': 'Режим Builder: Технические задания для разработчиков',
  'pricing.builder.feature4': 'Структурированный обзор проекта',
  'pricing.builder.feature5': 'Пользовательские сценарии и ключевые функции',
  'pricing.builder.feature6': 'Технические заметки',
  'pricing.builder.feature7': 'Определение того, что не входит в цели',
  'pricing.builder.feature8': 'Лимит честного использования',
  'pricing.builder.limitNote': 'Лимит честного использования',
  'pricing.monthlyReset': 'Ежемесячный сброс',

  // Modal
  'pricing.modal.selected': 'выбрано',
  'pricing.modal.comingSoon':
    'Регистрация и обработка платежей будут доступны в ближайшее время.',
  'pricing.modal.patience':
    'Мы работаем над тем, чтобы предоставить вам безопасный и удобный опыт. Пожалуйста, наберитесь терпения.',
  'pricing.modal.understood': 'Понятно',

  // FAQ
  'faq.title': 'Часто задаваемые вопросы',
  'faq.subtitle': 'Ответы честные и критические.',
  'faq.q1': "Что IdeaVerdict реально делает?",
  'faq.a1': "Оценивает вашу бизнес-идею по тому, что определяет исход — реальный спрос, конкуренция, требуемый капитал, время выхода на рынок и масштабируемость.\nЕсли идея состоятельна, мы покажем, как её заточить.\nЕсли нет — скажем и это.",
  'faq.q2': "Вы ещё и генерируете идеи?",
  'faq.a2': "Да — но никаких случайных предложений из шляпы.\nИдеи рождаются из реальных рыночных пробелов, а не из того, что в тренде на этой неделе.",
  'faq.q3': "Вы улучшаете существующие бизнес-модели?",
  'faq.a3': "Да, если есть что улучшать.\nМы не полируем сломанные идеи — мы усиливаем те, у которых уже есть фундамент.",
  'faq.q4': "Чем вы отличаетесь от других ИИ-инструментов?",
  'faq.a4': "Большинство ИИ-инструментов говорят, что ваша идея отличная.\nМы говорим, действительно ли это так.\nРазница: реализм вместо энтузиазма.",
  'faq.q5': "Это гарантирует успех?",
  'faq.a5': "Нет.\nМы помогаем избежать плохих ставок — риск никуда не денется, но вы войдёте с открытыми глазами.",
  'faq.q6': "Для кого IdeaVerdict?",
  'faq.a6': "Для основателей до запуска.\nДля строителей до сайд-проекта на выходных.\nДля операторов до их следующей ставки.\nДля инвесторов до подписи.\n\nДля всех, кому нужна ясность до обязательств.",
  'faq.q7': "А если я просто хочу подтверждения?",
  'faq.a7': "Тогда IdeaVerdict — не тот инструмент.\nМы выдаём честную оценку, а не утешение.",
  'faq.q8': "Насколько на самом деле честен анализ?",
  'faq.a8': "Настолько честен, насколько позволяют данные.\nМы не смягчаем слабый вердикт ради чьих-то чувств.",
  'faq.q9': "Это заменяет настоящее маркетинговое исследование?",
  'faq.a9': "Нет.\nЭто быстрая стратегическая проверка перед инвестициями — не 50-страничное рыночное исследование.",
  'faq.q10': "Почему так прямо?",
  'faq.a10': "Потому что построить не то стоит месяцев.\nЧестный вердикт стоит минут.\n\nМы выбираем минуты.",
  // Footer
  'footer.description':
    'IdeaVerdict не для того, чтобы вам было приятно. Он для того, чтобы вы решили правильно.',
  'footer.product': 'Продукт',
  'footer.aiAssistant': 'ИИ-ассистент',
  'footer.howItWorks': 'Как это работает',
  'footer.pricing': 'Цены',
  'footer.faq': 'Часто задаваемые вопросы',
  'footer.legal': 'Юридическая информация',
  'footer.privacy': 'Конфиденциальность',
  'footer.terms': 'Условия',
  'footer.imprint': 'Выходные данные',
  'footer.support': 'Поддержка',
  'footer.contact': 'Контакты',
  'footer.documentation': 'Документация',
  'footer.copyright': '© 2026 IdeaVerdict. Все права защищены.',

  // AI Assistant
  'aiAssistant.title': 'ИИ-ассистент по нишам',
  'aiAssistant.subtitle': 'Спросите о нишах',
  'aiAssistant.welcomeMessage':
    'Привет! Опишите свою идею или спросите меня о нише. Я дам вам честную и понятную оценку.',
  'aiAssistant.demoResponse':
    'Это демо-версия. Чтобы получить реальные оценки ИИ, пожалуйста, зарегистрируйтесь и выберите тариф.',
  'aiAssistant.placeholder': 'Опишите вашу идею...',

  // Header & Sidebar
  'dashboard.header.title': 'Панель управления',
  'dashboard.header.aiAssistant': 'Ваш ИИ-ассистент',
  'header.logout': 'Выйти',
  'dashboard.sidebar.overview': 'Обзор',
  'dashboard.sidebar.aiChat': 'ИИ-ассистент',
  'dashboard.sidebar.newAnalysis': 'ИИ-ассистент',
  'dashboard.sidebar.history': 'История',
  'dashboard.sidebar.credits': 'Кредиты',
  'dashboard.sidebar.settings': 'Настройки',

  // Dashboard Overview
  'dashboard.overview.welcome': 'С возвращением, {{name}}',
  'dashboard.overview.subtitle':
    'Вот краткий обзор вашей активности',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Осталось кредитов',
  'dashboard.stats.totalAnalyses': 'Всего анализов',
  'dashboard.stats.goodRatings': 'Положительных оценок',
  'dashboard.stats.nextReset': 'Следующий сброс через',
  'dashboard.stats.days': 'дн.',

  // Quick Actions
  'dashboard.quickActions.title': 'Быстрые действия',
  'dashboard.quickActions.checkNewIdea': 'Проверить идею',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Проанализировать существующую бизнес-идею',
  'dashboard.quickActions.generateIdea': 'Сгенерировать идею',
  'dashboard.quickActions.generateIdeaDesc':
    'Найти новую прибыльную нишу',
  'dashboard.quickActions.builderBriefing': 'Техническое задание',
  'dashboard.quickActions.builderBriefingDesc':
    'Превратить идею в задание для разработчика',
  'dashboard.quickActions.premiumOnly': 'Только Builder',

  // Chat Header
  'chat.title': 'ИИ-ассистент по нишам',
  'chat.subtitle':
    'Задавайте вопросы о нишах. Я оцениваю критически и честно.',
  'chat.creditsLabel': 'Кредиты',

  // Chat Welcome
  'chat.welcomeTitle': 'Добро пожаловать в ИИ-ассистент по нишам',
  'chat.welcomeDesc':
    'Опишите свою идею или спросите о нише. Я оценю её честно: Хорошо, Средне или Плохо.',
  'chat.aiWelcome':
    'Привет! Опишите свою идею или спросите меня о нише. Я дам вам честную и понятную оценку.',

  // Chat Suggestions
  'chat.suggestion1': 'Хочу создать SaaS-инструмент для фрилансеров по управлению счетами. Это хорошая ниша?',
  'chat.suggestion2': 'Найди мне онлайн-бизнес с низкой конкуренцией, который можно запустить за $500 без навыков программирования.',
  'chat.suggestion3': 'Оцени это: AI-приложение для планирования питания для занятых родителей с диетическими ограничениями.',
  'chat.suggestion4': 'Хочу продавать цифровые шаблоны на Etsy для малого бизнеса. Честно проанализируй эту нишу.',

  // Chat Actions
  'chat.newConversation': 'Новый чат',
  'chat.today': 'Сегодня',
  'chat.yesterday': 'Вчера',
  'chat.thisWeek': 'На этой неделе',
  'chat.thisMonth': 'В этом месяце',
  'chat.older': 'Раньше',
  'chat.messages': 'сообщений',
  'chat.renameConversation': 'Переименовать',
  'chat.deleteConversation': 'Удалить',
  'chat.cancel': 'Отмена',
  'chat.rename': 'Переименовать',
  'chat.delete': 'Удалить',
  'chat.favorite': 'В избранное',
  'chat.unfavorite': 'Убрать из избранного',
  'chat.searchSessions': 'Поиск чатов...',
  'chat.noResults': 'Ничего не найдено',
  'chat.noSessions': 'Чатов пока нет',
  'chat.enterNewName': 'Введите новое имя...',
  'chat.deleteConfirmMessage':
    'Вы уверены, что хотите удалить этот чат? Это действие нельзя отменить.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Введите ваш вопрос… (стоит 30 кредитов)',
  'chat.send': 'Отправить',
  'chat.voice': 'Голос',
  'chat.listeningPlaceholder': 'Слушаю... Говорите сейчас.',
  'chat.stopListening': 'Остановить',
  'chat.recording': 'Запись...',
  'chat.speechNotSupported': 'Ваш браузер не поддерживает голосовой ввод.',
  'chat.microphonePermissionDenied': 'Доступ к микрофону запрещён. Пожалуйста, разрешите доступ в настройках браузера.',
  'chat.errorNotEnoughCredits':
    'Недостаточно кредитов. Пожалуйста, обновите тариф или дождитесь следующего сброса.',
  'chat.errorAiFailed': 'Ошибка ответа ИИ. Кредиты не были списаны.',
  'chat.errorRateLimit': 'Слишком много запросов. Пожалуйста, подождите.',

  // Ratings
  'rating.good': 'Хорошо',
  'rating.medium': 'Средне',
  'rating.bad': 'Плохо',

  // Auth Page
  'auth.branding.headline1': 'Не каждая идея хороша.',
  'auth.branding.headline2': 'Мы говорим честно.',
  'auth.branding.subtitle':
    'ИИ для принятия решений о бизнес-нишах. Чётко. Критично. Без приукрашиваний.',
  'auth.benefits.privacy.title': '100% Конфиденциально',
  'auth.benefits.privacy.desc':
    'Ваши идеи остаются полностью приватными и защищёнными.',
  'auth.benefits.honest.title': 'Честный ИИ',
  'auth.benefits.honest.desc':
    'Никаких приукрашиваний – только чёткая, критичная обратная связь.',
  'auth.benefits.fast.title': 'Быстрые результаты',
  'auth.benefits.fast.desc': 'Получите ясность о вашей нише за несколько минут.',
  'auth.trust.users': 'Активных пользователей',
  'auth.trust.ideas': 'Идей проанализировано',
  'auth.trust.rating': 'Рейтинг пользователей',
  'auth.login.title': 'Вход',
  'auth.login.headline': 'С возвращением',
  'auth.login.subtitle': 'Войдите, чтобы продолжить.',
  'auth.login.forgotPassword': 'Забыли пароль?',
  'auth.login.submit': 'Войти',
  'auth.login.noAccount': 'Нет аккаунта?',
  'auth.login.signUp': 'Зарегистрироваться',
  'auth.register.title': 'Регистрация',
  'auth.register.headline': 'Создайте аккаунт',
  'auth.register.subtitle':
    'Начните анализировать свои бизнес-идеи сегодня.',
  'auth.register.submit': 'Создать аккаунт',
  'auth.register.hasAccount': 'Уже есть аккаунт?',
  'auth.register.signIn': 'Войти',
  'auth.fields.name': 'Полное имя',
  'auth.fields.email': 'Адрес электронной почты',
  'auth.fields.password': 'Пароль',
  'auth.fields.confirmPassword': 'Подтвердите пароль',
  'auth.fields.selectPlan': 'Выберите тариф',
  'auth.fields.testCode': 'Код для тестового доступа',
  'auth.placeholders.name': 'Введите ваше имя',
  'auth.placeholders.email': 'Введите ваш email',
  'auth.placeholders.password': 'Введите пароль',
  'auth.placeholders.confirmPassword': 'Подтвердите пароль',
  'auth.placeholders.testCode': 'Введите тестовый код',
  'auth.terms.accept': 'Я принимаю',
  'auth.terms.terms': 'Условия использования',
  'auth.privacy.accept': 'Я принимаю',
  'auth.privacy.policy': 'Политику конфиденциальности',
  'auth.errors.nameRequired': 'Имя обязательно',
  'auth.errors.emailRequired': 'Email обязателен',
  'auth.errors.emailInvalid': 'Пожалуйста, введите корректный email',
  'auth.errors.passwordRequired': 'Пароль обязателен',
  'auth.errors.passwordLength': 'Пароль должен содержать не менее 8 символов',
  'auth.errors.passwordMismatch': 'Пароли не совпадают',
  'auth.errors.invalidCode': 'Неверный или просроченный код',
  'auth.errors.registrationCodeOnly': 'Этот код предназначен только для регистрации',
  'auth.errors.verificationFailed': 'Ошибка проверки кода. Пожалуйста, попробуйте снова.',
  'auth.loading': 'Пожалуйста, подождите...',
  'auth.or': 'или продолжить с',
  'auth.social.google': 'Продолжить с Google',
  'auth.social.apple': 'Продолжить с Apple',
  'auth.actions.verify': 'Проверить',
  'auth.testCode.activated': 'Тестовый код активирован!',
  'auth.testCode.days': 'дней',
  'auth.testCode.months': 'месяцев',
  'auth.testCode.freeAccess': 'бесплатного доступа',
  'auth.testCode.credits': 'кредитов',

  // Email Verification
  'auth.verification.title': 'Подтверждение email',
  'auth.verification.headline': 'Проверьте ваш почтовый ящик',
  'auth.verification.subtitle': 'Мы отправили код подтверждения на:',
  'auth.verification.codeLabel': 'Код подтверждения',
  'auth.verification.codePlaceholder': 'Введите 6-значный код',
  'auth.verification.submit': 'Подтвердить email',
  'auth.verification.resend': 'Отправить код повторно',
  'auth.verification.resendIn': 'Повторная отправка через',
  'auth.verification.seconds': 'секунд',
  'auth.verification.success': 'Email успешно подтверждён!',
  'auth.verification.error': 'Неверный код. Пожалуйста, попробуйте снова.',
  'auth.verification.expired': 'Код истёк. Пожалуйста, запросите новый.',
  'auth.verification.sent': 'Новый код отправлен!',
  'auth.verification.checkSpam':
    'Не получили письмо? Проверьте папку со спамом.',

  // Forgot Password
  'auth.forgot.title': 'Забыли пароль',
  'auth.forgot.headline': 'Сброс пароля',
  'auth.forgot.subtitle':
    'Введите ваш email, и мы отправим вам ссылку для сброса пароля.',
  'auth.forgot.submit': 'Отправить ссылку',
  'auth.forgot.backToLogin': 'Вернуться ко входу',
  'auth.forgot.success': 'Письмо отправлено!',
  'auth.forgot.successMessage':
    'Мы отправили вам инструкции по сбросу пароля на email.',
  'auth.forgot.checkInbox': 'Проверьте ваш почтовый ящик',

  // Reset Password
  'auth.reset.title': 'Новый пароль',
  'auth.reset.headline': 'Установите новый пароль',
  'auth.reset.subtitle': 'Введите ваш новый пароль.',
  'auth.reset.newPassword': 'Новый пароль',
  'auth.reset.confirmNewPassword': 'Подтвердите новый пароль',
  'auth.reset.submit': 'Изменить пароль',
  'auth.reset.success': 'Пароль успешно изменён!',
  'auth.reset.successMessage':
    'Теперь вы можете войти с новым паролем.',
  'auth.reset.loginNow': 'Войти сейчас',

  // Legal Pages
  'legal.backToAuth': 'Вернуться ко входу',
  'legal.allRightsReserved': 'Все права защищены.',

  // Terms Page
  'legal.terms.title': 'Условия использования',
  'legal.terms.lastUpdated': 'Последнее обновление',
  'legal.terms.section1.title': '1. Сфера действия',
  'legal.terms.section1.content':
    'Настоящие Условия использования применяются ко всем договорам между NicheFinder (далее "Поставщик") и пользователем (далее "Клиент") относительно использования платформы для анализа ниш на основе ИИ.',
  'legal.terms.section2.title': '2. Описание услуги',
  'legal.terms.section2.content':
    'Поставщик предлагает платформу на основе ИИ, которая анализирует и оценивает бизнес-идеи и ниши. Услуги включают:',
  'legal.terms.section2.item1': 'Анализ бизнес-идей с помощью ИИ',
  'legal.terms.section2.item2': 'Оценку рыночного потенциала и конкуренции',
  'legal.terms.section2.item3': 'Генерацию предложений ниш',
  'legal.terms.section2.item4': 'Создание технических заданий для разработчиков (пакет Builder)',
  'legal.terms.section3.title': '3. Заключение договора и регистрация',
  'legal.terms.section3.content':
    'Договор заключается посредством регистрации на платформе и выбора пакета. Клиент подтверждает:',
  'legal.terms.section3.item1': 'Достижение совершеннолетия и полную дееспособность',
  'legal.terms.section3.item2': 'Предоставление достоверной информации при регистрации',
  'legal.terms.section3.item3': 'Надёжное хранение учётных данных',
  'legal.terms.section4.title': '4. Кредиты и оплата',
  'legal.terms.section4.content':
    'Использование функций ИИ основано на кредитной системе. Каждый запрос к ИИ стоит 30 кредитов. Кредиты списываются только при успешном ответе. Неиспользованные кредиты аннулируются в конце расчётного периода и не возмещаются.',
  'legal.terms.section5.title': '5. Отказ от ответственности',
  'legal.terms.section5.content':
    'Оценки ИИ служат лишь вспомогательным средством для принятия решений и не гарантируют успеха в бизнесе. Поставщик не несёт ответственности за решения, принятые на основе анализов ИИ. Ответственность за умысел и грубую неосторожность остаётся незатронутой.',
  'legal.terms.section6.title': '6. Защита данных и конфиденциальность',
  'legal.terms.section6.content':
    'Все представленные бизнес-идеи обрабатываются конфиденциально и не передаются третьим лицам. Обработка персональных данных осуществляется в соответствии с нашей Политикой конфиденциальности и применимым законодательством о защите данных.',
  'legal.terms.section7.title': '7. Расторжение',
  'legal.terms.section7.content':
    'Клиент может отменить подписку в любое время с окончанием текущего расчётного периода. В случае нарушения настоящих Условий Поставщик оставляет за собой право заблокировать доступ к платформе.',
  'legal.terms.section8.title': '8. Заключительные положения',
  'legal.terms.section8.content':
    'Применяется швейцарское право. Местом юрисдикции является Цюрих, Швейцария. Если отдельные положения настоящих Условий будут признаны недействительными, действительность остальных положений сохраняется.',
  'legal.terms.contact.title': 'Вопросы об Условиях?',
  'legal.terms.contact.content':
    'Если у вас есть вопросы об этих Условиях использования, пожалуйста, свяжитесь с нами по адресу:',

  // Privacy Page
  'legal.privacy.title': 'Политика конфиденциальности',
  'legal.privacy.section1.title': '1. Контролёр данных',
  'legal.privacy.section1.content':
    'Контролёром данных для этого веб-сайта является NicheFinder, Цюрих, Швейцария. Мы очень серьёзно относимся к защите ваших персональных данных и обрабатываем ваши персональные данные конфиденциально и в соответствии с законодательными нормами о защите данных.',
  'legal.privacy.section2.title': '2. Собираемые данные',
  'legal.privacy.section2.content':
    'Мы собираем и обрабатываем следующие персональные данные:',
  'legal.privacy.section2.item1':
    'Регистрационные данные: Имя, адрес электронной почты, пароль (в зашифрованном виде)',
  'legal.privacy.section2.item2':
    'Данные об использовании: IP-адрес, тип браузера, время доступа',
  'legal.privacy.section2.item3':
    'Бизнес-идеи и запросы по нишам (хранятся анонимно)',
  'legal.privacy.section2.item4':
    'Платёжная информация (через безопасных сторонних провайдеров)',
  'legal.privacy.section3.title': '3. Цель обработки данных',
  'legal.privacy.section3.content':
    'Ваши данные используются для следующих целей:',
  'legal.privacy.section3.item1':
    'Предоставление и улучшение наших услуг ИИ',
  'legal.privacy.section3.item2':
    'Управление аккаунтом и аутентификация',
  'legal.privacy.section3.item3':
    'Выставление счетов и обработка платежей',
  'legal.privacy.section4.title': '4. Безопасность данных',
  'legal.privacy.section4.content':
    'Мы внедряем технические и организационные меры безопасности для защиты ваших данных от манипуляции, потери, уничтожения или несанкционированного доступа. Все передачи данных шифруются с помощью SSL/TLS.',
  'legal.privacy.section5.title': '5. Конфиденциальность ваших бизнес-идей',
  'legal.privacy.section5.content':
    'Ваши представленные бизнес-идеи и запросы по нишам обрабатываются строго конфиденциально. Они не передаются третьим лицам, не используются для целей обучения и могут быть полностью удалены по запросу. Ваши идеи принадлежат вам.',
  'legal.privacy.section6.title': '6. Ваши права',
  'legal.privacy.section6.content':
    'Вы имеете следующие права в отношении ваших персональных данных:',
  'legal.privacy.section6.item1': 'Право на доступ к хранимым данным',
  'legal.privacy.section6.item2': 'Право на исправление неточных данных',
  'legal.privacy.section6.item3': 'Право на удаление ваших данных',
  'legal.privacy.section6.item4': 'Право на переносимость данных',
  'legal.privacy.section7.title': '7. Файлы cookie',
  'legal.privacy.section7.content':
    'Наш веб-сайт использует только технически необходимые файлы cookie для аутентификации и управления сеансами. Мы не используем отслеживающие cookie или инструменты аналитики третьих лиц без вашего явного согласия.',
  'legal.privacy.section8.title': '8. Изменения в настоящей Политике конфиденциальности',
  'legal.privacy.section8.content':
    'Мы оставляем за собой право адаптировать эту политику конфиденциальности в соответствии с изменениями законодательства или изменениями в услугах. Актуальная версия всегда доступна на этой странице.',
  'legal.privacy.contact.title': 'Вопросы о конфиденциальности?',
  'legal.privacy.contact.content':
    'Если у вас есть вопросы об обработке ваших персональных данных, пожалуйста, свяжитесь с нами по адресу:',

  'auth.passwordStrength.label': 'Надёжность пароля',
  'auth.passwordStrength.weak': 'Слабый',
  'auth.passwordStrength.medium': 'Средний',
  'auth.passwordStrength.strong': 'Сильный',
  'auth.passwordStrength.veryStrong': 'Очень сильный',
  'auth.passwordStrength.minLength': 'Мин. 8 символов',
  'auth.passwordStrength.uppercase': 'Заглавная буква',
  'auth.passwordStrength.number': 'Цифра',
  'auth.passwordStrength.special': 'Специальный символ',

  trial: {
    subtitle: 'Бесплатный пробный период',
    upgrade: 'Обновить сейчас',
    creditsRemaining: 'осталось кредитов',
    inputHint: 'Пробная версия - История чатов недоступна',
    banner: {
      title: 'Активен 7-дневный пробный период',
      remaining: 'осталось {{days}} дней',
      credits: 'доступно кредитов',
      upgradeNow: 'Обновить сейчас',
    },
    welcome: {
      title: 'Добро пожаловать в бесплатный пробный период!',
      desc: 'Тестируйте нашего ИИ-ассистента бесплатно 7 дней с 100 кредитами. Задавайте вопросы и открывайте возможности!',
    },
    info: {
      title: 'Ограничения пробного периода',
      credits: '100 кредитов на 7 дней',
      noHistory: 'Нет истории чатов',
      noSettings: 'Ограниченные возможности',
      upgrade: 'Обновитесь для полного доступа',
    },
  },

  // ─── Settings Page ────────────────────────────────────────────────────────────
  'settings.title': 'Настройки',
  'settings.subtitle': 'Управляйте аккаунтом и предпочтениями',
  'settings.backToOverview': 'Вернуться к обзору',
  'settings.subscriptionLink': 'Подписка и оплата',
  'settings.saved': 'Изменения успешно сохранены',
  'settings.changesSaved': 'Изменения сохранены',
  'settings.saveChanges': 'Сохранить изменения',
  'settings.dataExported': 'Данные успешно экспортированы',

  // Tabs
  'settings.tabs.profile': 'Профиль',
  'settings.tabs.preferences': 'Предпочтения',
  'settings.tabs.notifications': 'Уведомления',
  'settings.tabs.account': 'Аккаунт и тариф',

  // Profile
  'settings.profile.changePhoto': 'Изменить фото',
  'settings.profile.photoHint': 'JPG, PNG или GIF (макс. 2MB)',
  'settings.profile.uploading': 'Загрузка...',
  'settings.profile.photoUpdated': 'Фото профиля обновлено!',
  'settings.profile.name': 'Имя',
  'settings.profile.email': 'Email',
  'settings.profile.phone': 'Телефон',
  'settings.profile.changePassword': 'Изменить пароль',
  'settings.profile.currentPassword': 'Текущий пароль',
  'settings.profile.newPassword': 'Новый пароль',
  'settings.profile.confirmPassword': 'Подтвердите пароль',

  // Preferences
  'settings.preferences.language': 'Язык',
  'settings.preferences.chooseLanguage': 'Выберите язык',
  'settings.preferences.timezone': 'Часовой пояс',
  'settings.preferences.currency': 'Валюта',

  // Notifications
  'settings.notifications.emailTitle': 'Уведомления по email',
  'settings.notifications.email.analysis': 'Анализ завершён',
  'settings.notifications.email.analysisDesc': 'Получать email, когда анализ готов',
  'settings.notifications.email.credits': 'Обновления кредитов',
  'settings.notifications.email.creditsDesc': 'Уведомления о кредитах и сбросах',
  'settings.notifications.email.billing': 'Счета и платежи',
  'settings.notifications.email.billingDesc': 'Уведомления о счетах и изменениях тарифа',
  'settings.notifications.email.newsletter': 'Новостная рассылка',
  'settings.notifications.email.newsletterDesc': 'Советы, обновления и новые функции',
  'settings.notifications.pushTitle': 'Push-уведомления',
  'settings.notifications.push.analysis': 'Анализ завершён',
  'settings.notifications.push.analysisDesc': 'Уведомление в браузере, когда анализ готов',
  'settings.notifications.push.credits': 'Предупреждения о кредитах',
  'settings.notifications.push.creditsDesc': 'Предупреждение при низком балансе кредитов',

  // Account
  'settings.account.currentSubscription': 'Текущая подписка',
  'settings.account.plan': 'Тариф',
  'settings.account.price': 'Цена',
  'settings.account.nextBilling': 'Следующая оплата',
  'settings.account.manageSubscription': 'Управление подпиской и платежами',
  'settings.account.dataPrivacy': 'Данные и конфиденциальность',
  'settings.account.exportData': 'Экспорт данных',
  'settings.account.deleteAccount': 'Удалить аккаунт',

  // Delete Modal
  'settings.deleteModal.title': 'Удалить аккаунт?',
  'settings.deleteModal.subtitle': 'Все данные будут удалены безвозвратно.',
  'settings.deleteModal.warning1': 'Все анализы и данные будут удалены',
  'settings.deleteModal.warning2': 'Активная подписка будет немедленно отменена',
  'settings.deleteModal.warning3': 'Возврат средств невозможен',
  'settings.deleteModal.confirmLabel': 'Введите "{{word}}" для подтверждения *',
  'settings.deleteModal.cancel': 'Отмена',
  'settings.deleteModal.confirm': 'Удалить аккаунт',

  // ─── Subscription & Billing ─────────────────────────────
  'sub.backToOverview': 'Вернуться к обзору',
  'sub.settings': 'Настройки',
  'sub.title': 'Подписка и оплата',
  'sub.subtitle': 'Управляйте подпиской, способами оплаты и счетами',
  'sub.tab.overview': 'Обзор',
  'sub.tab.payment': 'Способы оплаты',
  'sub.tab.billing': 'Платёжный адрес',
  'sub.tab.history': 'История платежей',
  'sub.memberSince': 'Пользователь с',
  'sub.perMonth': 'в месяц',
  'sub.baseCHF': '(CHF {{amount}} базовая)',
  'sub.nextBilling': 'Следующая оплата',
  'sub.creditsUsed': 'Использовано кредитов',
  'sub.paymentMethod': 'Способ оплаты',
  'sub.creditUsage': 'Использование кредитов',
  'sub.changePlan': 'Сменить тариф',
  'sub.reactivate': 'Реактивировать',
  'sub.cancelSub': 'Отменить подписку',
  'sub.manageCards': 'Управление картами',
  'sub.downloadInvoices': 'Скачать счета',
  'sub.invoicesAvailable': '{{count}} счетов в формате PDF',
  'sub.accountSettings': 'Настройки аккаунта',
  'sub.profileNotifications': 'Профиль, уведомления и другое',
  // Prices in EUR info
  'sub.eurInfo': 'Цены указаны в',
  'sub.eurLabel': 'Евро',
  'sub.eurRate': 'Курс:',
  'sub.currentRate': 'Текущий курс',
  // Payment Methods
  'sub.savedCards': 'Сохранённые карты',
  'sub.newCard': 'Новая карта',
  'sub.default': 'По умолчанию',
  'sub.setDefault': 'Сделать основной',
  'sub.validUntil': 'Действительна до',
  'sub.noCards': 'Нет сохранённых карт',
  'sub.addFirstCard': 'Добавить первую карту',
  'sub.securePayments': 'Безопасные платежи',
  'sub.securePaymentsDesc': 'Все платёжные данные передаются зашифрованными и надежно хранятся у нашего платёжного провайдера. Мы не храним полные номера карт.',
  // Billing Address
  'sub.billingAddress': 'Платёжный адрес',
  'sub.edit': 'Редактировать',
  'sub.name': 'Имя',
  'sub.streetAddress': 'Улица и номер',
  'sub.zip': 'Почтовый индекс',
  'sub.city': 'Город',
  'sub.country': 'Страна',
  'sub.address': 'Адрес',
  'sub.save': 'Сохранить',
  'sub.cancel': 'Отмена',
  'sub.country.switzerland': 'Швейцария',
  'sub.country.germany': 'Германия',
  'sub.country.austria': 'Австрия',
  'sub.country.netherlands': 'Нидерланды',
  'sub.country.belgium': 'Бельгия',
  // Payment History
  'sub.paymentHistory': 'История платежей',
  'sub.allInvoicesPDF': 'Скачать все счета в формате PDF с логотипом',
  'sub.downloadAll': 'Скачать все',
  'sub.eurInvoiceNote': 'Счета всегда выставляются в CHF. Указанные суммы в EUR приведены только для справки.',
  'sub.date': 'Дата',
  'sub.description': 'Описание',
  'sub.net': 'Нетто',
  'sub.vat': 'НДС',
  'sub.total': 'Итого',
  'sub.status': 'Статус',
  'sub.pdf': 'PDF',
  'sub.invoices': 'счетов',
  'sub.totalAmount': 'Общая сумма',
  // Change Plan Modal
  'sub.changePlanTitle': 'Сменить тариф',
  'sub.current': 'Текущий',
  'sub.month': '/мес',
  'sub.showLess': 'Показать меньше',
  'sub.showMore': '+{{count}} ещё',
  'sub.switchPlan': 'Сменить тариф',
  'sub.eurPriceNote': 'Цены указаны в EUR ({{note}}). Списание происходит в CHF.',
  // Cancel Modal
  'sub.cancelTitle': 'Действительно отменить подписку?',
  'sub.cancelIrreversible': 'Это действие нельзя отменить.',
  'sub.cancelWarning1': 'Все оставшиеся кредиты будут аннулированы',
  'sub.cancelWarning2': 'Переход на бесплатный тариф',
  'sub.cancelWarning3': 'Потеря всех премиум-функций',
  'sub.pauseInstead': 'Альтернатива: Приостановить подписку?',
  'sub.pauseDesc': 'Приостановите подписку и сохраните данные.',
  'sub.preferPause': 'Предпочитаю приостановить',
  'sub.cancelReason': 'Причина отмены',
  'sub.selectReason': 'Пожалуйста, выберите...',
  'sub.reason.tooExpensive': 'Слишком дорого',
  'sub.reason.notUsing': 'Недостаточно использую',
  'sub.reason.missingFeatures': 'Не хватает функций',
  'sub.reason.foundAlternative': 'Нашёл альтернативу',
  'sub.reason.other': 'Другое',
  'sub.confirmType': 'Подтверждение: Введите "CANCEL" *',
  'sub.cancelNow': 'Отменить сейчас',
  // Add Card Modal
  'sub.addCardTitle': 'Добавить новую карту',
  'sub.cardHolder': 'Владелец карты *',
  'sub.cardNumber': 'Номер карты *',
  'sub.expiryDate': 'Срок действия *',
  'sub.addCard': 'Добавить карту',
  // Change Card Modal
  'sub.choosePayment': 'Выберите способ оплаты',
  'sub.active': 'Активен',
  'sub.close': 'Закрыть',
  // Toast messages
  'sub.toast.cancelled': 'Ваша подписка отменена с окончанием текущего расчётного периода.',
  'sub.toast.reactivated': 'Ваша подписка успешно реактивирована!',
  'sub.toast.planChanged': 'Тариф успешно изменён на {{plan}}!',
  'sub.toast.defaultChanged': 'Основной способ оплаты изменён.',
  'sub.toast.cannotDeleteDefault': 'Основную карту нельзя удалить.',
  'sub.toast.cardRemoved': 'Карта удалена.',
  'sub.toast.fillAll': 'Пожалуйста, заполните все поля.',
  'sub.toast.cardAdded': 'Новая карта успешно добавлена!',
  'sub.toast.billingSaved': 'Платёжный адрес сохранён.',
  'sub.toast.invoiceDownloaded': 'Счёт {{id}} скачан!',
  'sub.toast.pdfError': 'Ошибка создания PDF.',
  // Chat interface
  'sub.notEnoughCredits': 'Недостаточно кредитов',
  'sub.needCredits': 'Для одного вопроса необходимо {{count}} кредитов.',
  'sub.creditsLow': 'Заканчиваются кредиты',
  'sub.questionsLeft': 'Возможно {{count}} вопросов.',
  'sub.plan': 'Тариф',
  'sub.base': 'базовый',
  'sub.unlimited': 'Безлимитно',
  'sub.status.active': 'Активна',
  'sub.status.cancelled': 'Отменена',
  'sub.status.paused': 'Приостановлена',
  'sub.invoice': 'СЧЕТ',
  'sub.from': 'ОТ',
  'sub.to': 'ДЛЯ',
  'sub.vatId': 'ИНН',
  'sub.tel': 'Тел',
  'sub.invoiceDate': 'Дата счёта',
  'sub.invoiceNumber': 'Номер счёта',
  'sub.paymentStatus': 'Статус платежа',
  'sub.creditCard': 'Кредитная карта',
  'sub.quantity': 'КОЛ-ВО',
  'sub.price': 'ЦЕНА',
  'sub.amount': 'СУММА',
  'sub.subtotal': 'Промежуточный итог',
  'sub.bank': 'Банк',
  'sub.card': 'Карта',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'John Doe',

  // ─── Admin Panel ─────────────────────────────────────────────────────────────
  'admin.title': 'Панель администратора',
  'admin.subtitle': 'Центр управления',
  'admin.superAdmin': 'Супер администратор',
  'admin.logout': 'Выйти',
  'admin.tabs.users': 'Управление пользователями',
  'admin.tabs.downgrades': 'Понижения',
  'admin.tabs.tips': 'Совет дня',
  'admin.tabs.coupons': 'Промокоды',
  'admin.tabs.website': 'Редактор сайта',
  'admin.tabs.ai': 'Настройки ИИ',
  'admin.tabs.transactions': 'Журнал транзакций',
  'admin.tabs.stats': 'Статистика',
  'admin.users.searchPlaceholder': 'Поиск пользователей (email или имя)...',
  'admin.users.manageSubscription': 'Управление подпиской',
  'admin.users.grantFree': 'Предоставить бесплатный доступ',
  'admin.users.blockUser': 'Заблокировать пользователя',
  'admin.users.cancellationPlaceholder': 'Почему подписка отменяется?',
  'admin.users.selectPlan': 'Выберите тариф',
  'admin.users.subChanged': 'Подписка {{name}} изменена на {{plan}}',
  'admin.users.noReasonGiven': 'Причина не указана',
  'admin.users.subCancelled': 'Подписка {{name}} отменена (действительна до {{date}})',
  'admin.users.paused': 'Приостановлена',
  'admin.users.subPaused': 'Подписка {{name}} приостановлена',
  'admin.users.subReactivated': 'Подписка {{name}} реактивирована',
  'admin.users.freeAccount': 'Бесплатный аккаунт',
  'admin.users.blocked': 'Заблокирован',
  'admin.users.cancelledExpiring': 'Отменена (истекает)',
  'admin.users.cancelledOn': 'Отменена:',
  'admin.users.endsOn': 'Заканчивается:',
  'admin.users.daysRemaining': 'дней осталось',
  'admin.users.expired': '(Истекла)',
  'admin.users.total': 'Всего:',
  'admin.users.usersLabel': 'пользователей',
  'admin.users.free': 'бесплатно',
  'admin.users.block': 'Заблокировать',
  'admin.users.unblock': 'Разблокировать',
  'admin.users.unblockUser': 'Разблокировать пользователя',
  'admin.users.selectAction': 'Выберите действие',
  'admin.users.cancelSub': 'Отменить подписку',
  'admin.users.cancelSubDesc': 'Отмена в конце месяца',
  'admin.users.pauseSub': 'Приостановить подписку',
  'admin.users.pauseSubDesc': 'Временная приостановка',
  'admin.users.changePlan': 'Сменить тариф',
  'admin.users.changePlanDesc': 'Переключиться на другой тариф',
  'admin.users.reactivateSub': 'Реактивировать подписку',
  'admin.users.reactivateDesc': 'Отменить отмену',
  'admin.users.alreadyCancelled': 'Подписка уже отменена',
  'admin.users.planLabel': 'Тариф',
  'admin.users.cancellationReasonOpt': 'Причина отмены (необязательно)',
  'admin.users.cancelInfo1': 'Подписка закончится',
  'admin.users.cancelInfo2': '(в конце месяца). До этого момента у пользователя будет полный доступ. Возврат средств не производится.',
  'admin.users.newPlan': 'Новый тариф',
  'admin.users.warning': 'Предупреждение',
  'admin.users.blockDesc': 'Пользователь будет немедленно вышел из системы и не сможет войти снова. Все активные сессии будут завершены.',
  'admin.users.confirmUnblock': 'Подтвердить разблокировку',
  'admin.users.unblockDesc': 'Пользователь сможет снова войти в систему и использовать все функции.',
  'admin.users.afterBlock': 'После блокировки:',
  'admin.users.afterUnblock': 'После разблокировки:',
  'admin.users.noAccountAccess': 'Нет доступа к аккаунту',
  'admin.users.noNewAnalyses': 'Новые анализы невозможны',
  'admin.users.creditsStored': 'Кредиты и история сохранены',
  'admin.users.accessRestored': 'Доступ к аккаунту восстановлен',
  'admin.users.allFeaturesAvail': 'Все функции снова доступны',
  'admin.users.creditsPreserved': 'Кредиты и история сохранены',
  'admin.users.downgrade': 'Понизить тариф',
  'admin.users.grantFreeBtn': 'Предоставить бесплатный',
  'admin.users.durationMonths': 'Длительность (месяцы)',
  'admin.users.months': 'месяц(ев)',
  'admin.users.freePlan': 'бесплатно',
  'admin.users.freeSummary': 'получает',
  'admin.users.withCredits': 'с',
  'admin.users.credits': 'Кредитами',
  'admin.users.subInfo': 'Информация о подписке',
  'admin.users.currentPlan': 'Текущий тариф',
  'admin.users.joined': 'Присоединился',
  'admin.users.totalSpent': 'Всего потрачено',
  'admin.users.paymentMethod': 'Способ оплаты',
  'admin.users.validThrough': 'Действительна до',
  'admin.users.billingAddress': 'Платёжный адрес',
  'admin.users.transactionHistory': 'История транзакций',
  'admin.users.cancellationDate': 'Дата отмены',
  'admin.users.validUntil': 'Действительна до (конец месяца)',
  'admin.users.cancellationReason': 'Причина отмены',
  'admin.users.noReason': 'Причина не указана',
  'admin.users.timeRemaining': 'Осталось времени',
  'admin.users.daysUntilDeactivation': 'дней до деактивации',
  'admin.table.user': 'Пользователь',
  'admin.table.plan': 'Тариф',
  'admin.table.subStatus': 'Статус подписки',
  'admin.table.cancellation': 'Отмена',
  'admin.table.payment': 'Способ оплаты',
  'admin.table.spending': 'Траты',
  'admin.table.actions': 'Действия',
  'admin.actions.viewDetails': 'Просмотреть детали',
  'admin.actions.manageSubscription': 'Управление подпиской',
  'admin.actions.grantFree': 'Предоставить бесплатный доступ',
  'admin.actions.block': 'Заблокировать пользователя',
  'admin.actions.unblock': 'Разблокировать пользователя',
  'admin.actions.cancel': 'Отмена',
  'admin.actions.save': 'Сохранить',
  'admin.actions.delete': 'Удалить',
  'admin.actions.confirm': 'Подтвердить',
  'admin.actions.done': 'Готово',
  'admin.actions.edit': 'Редактировать',
  'admin.actions.close': 'Закрыть',
  'admin.table.status': 'Статус',
  'admin.filter.all': 'Все',
  'admin.subscription.active': 'Активна',
  'admin.subscription.cancelled': 'Отменена',
  'admin.subscription.paused': 'Приостановлена',
  'admin.subscription.unknown': 'Неизвестно',
  'admin.status.active': 'Активен',
  'admin.status.inactive': 'Неактивен',
  'admin.status.pending': 'В ожидании',
  'admin.status.approved': 'Одобрено',
  'admin.status.rejected': 'Отклонено',
  'admin.coupons.title': 'Управление промокодами',
  'admin.coupons.subtitle': 'Создавайте и управляйте промокодами',
  'admin.coupons.newCoupon': 'Новый промокод',
  'admin.coupons.registrationCoupons': 'Регистрационные промокоды',
  'admin.coupons.trialCoupons': 'Промокоды для пробного доступа',
  'admin.coupons.type': 'Тип',
  'admin.coupons.plan': 'Тариф',
  'admin.coupons.value': 'Значение',
  'admin.coupons.usage': 'Использование',
  'admin.coupons.validUntil': 'Действителен до',
  'admin.coupons.created': 'Создан',
  'admin.coupons.actions': 'Действия',
  'admin.coupons.copyCode': 'Скопировать код',
  'admin.coupons.allPlans': 'Все тарифы',
  'admin.coupons.discount': 'Скидка',
  'admin.coupons.days': 'дней',
  'admin.coupons.months': 'месяцев',
  'admin.coupons.free': 'бесплатно',
  'admin.coupons.unlimited': 'Безлимитно',
  'admin.coupons.createRegistration': 'Создать регистрационный промокод',
  'admin.coupons.createTrial': 'Создать промокод для пробного доступа',
  'admin.coupons.couponCode': 'Промокод',
  'admin.coupons.codePlaceholder': 'например, NF-7X3K9M',
  'admin.coupons.generateCode': 'Сгенерировать новый код',
  'admin.coupons.alertFillRequired': 'Пожалуйста, заполните все обязательные поля',
  'admin.coupons.alertSelectExpiry': 'Пожалуйста, выберите дату истечения срока или включите "Безлимитная действительность"',
  'admin.coupons.alertCreateError': 'Ошибка создания промокода',
  'admin.coupons.confirmDelete': 'Вы уверены, что хотите удалить этот промокод?',
  'admin.coupons.discountPercent': 'Скидка (%)',
  'admin.coupons.bonusCredits': 'Бонусные кредиты',
  'admin.coupons.freeDuration': 'Бесплатная длительность',
  'admin.coupons.maxUses': 'Макс. использований',
  'admin.coupons.expiryDate': 'Дата истечения',
  'admin.coupons.unlimitedValidity': 'Безлимитная действительность',
  'admin.coupons.unlimitedUses': 'Неограниченное использование',
  'admin.coupons.trialCredits': 'Пробные кредиты',
  'admin.coupons.trialDuration': 'Пробная длительность',
  'admin.coupons.typePlaceholder': 'например, Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'Длительность',
  'admin.stats.totalUsers': 'Всего пользователей',
  'admin.stats.monthlyRevenue': 'Месячный доход',
  'admin.stats.activeSubscriptions': 'Активных подписок',
  'admin.stats.average': 'Среднее',
  'admin.stats.revenuePerUser': 'Доход на пользователя',
  'admin.stats.grossRevenue': 'Валовой доход',
  'admin.stats.net': 'НЕТТО',
  'admin.stats.netRevenue': 'Чистый доход',
  'admin.stats.churnRate': 'Коэффициент оттока',
  'admin.stats.planDistribution': 'Распределение по тарифам',
  'admin.stats.users': 'пользователей',
  'admin.stats.revenueByPlan': 'Доход по тарифам',
  'admin.stats.recentActivity': 'Недавняя активность',
  'admin.stats.activity1': 'Thomas Weber перешёл на тариф Builder',
  'admin.stats.activity2': 'Новый пользователь зарегистрировался',
  'admin.stats.activity3': 'Anna Schmidt перешла на тариф Pro',
  'admin.stats.hoursAgo2': '2 часа назад',
  'admin.stats.hoursAgo5': '5 часов назад',
  'admin.stats.dayAgo1': '1 день назад',
  'admin.stats.couponStats': 'Статистика промокодов',
  'admin.stats.totalRedemptions': 'Всего активаций',
  'admin.stats.activeCoupons': 'Активных промокодов',
  'admin.stats.registrationRedemptions': 'Активаций регистрационных',
  'admin.stats.trialRedemptions': 'Активаций пробных',
  'admin.stats.couponDistribution': 'Распределение промокодов',
  'admin.stats.registrationCoupons': 'Регистрационные промокоды',
  'admin.stats.trialCoupons': 'Пробные промокоды',
  'admin.stats.expiredInactive': 'Просрочены/Неактивны',
  'admin.stats.topCoupons': 'Лучшие промокоды по активациям',
  'admin.stats.redemptions': 'активаций',
  'admin.stats.noCouponsRedeemed': 'Промокоды ещё не активированы',
  'admin.downgrade.pending': 'в ожидании',
  'admin.downgrade.refunds': 'Возвраты',
  'admin.downgrade.sectionRequests': 'Запросы',
  'admin.downgrade.sectionStats': 'Статистика',
  'admin.downgrade.sectionRules': 'Правила',
  'admin.downgrade.pendingRequests': 'Ожидающие запросы',
  'admin.downgrade.approvedRequests': 'Одобренные запросы',
  'admin.downgrade.rejectedRequests': 'Отклонённые запросы',
  'admin.downgrade.activeRules': 'Активные правила',
  'admin.downgrade.autoRules': 'Правила автоматического понижения',
  'admin.downgrade.autoRulesDesc': 'Создавайте правила, которые автоматически запускают понижение на основе поведения пользователя',
  'admin.downgrade.newRule': 'Новое правило',
  'admin.downgrade.totalRules': 'Всего правил',
  'admin.downgrade.triggeredActions': 'Запущенные действия',
  'admin.downgrade.conditionsAnd': 'Условия (объединены AND)',
  'admin.downgrade.action': 'Действие',
  'admin.downgrade.successTitle': 'Понижение успешно!',
  'admin.downgrade.successDesc': 'Пользователь успешно понижен, возврат средств обработан.',
  'admin.downgrade.closing': 'Закрытие...',
  'admin.downgrade.title': 'Понижение пользователя',
  'admin.downgrade.currentPlan': 'Текущий тариф',
  'admin.downgrade.spending': 'Траты',
  'admin.downgrade.availablePlans': 'Доступные тарифы для понижения',
  'admin.downgrade.perMonth': 'в месяц',
  'admin.downgrade.refundCalc': 'Расчёт возврата',
  'admin.downgrade.currentPlanLabel': 'Текущий тариф',
  'admin.downgrade.newPlan': 'Новый тариф',
  'admin.downgrade.remainingDays': 'Оставшиеся дни',
  'admin.downgrade.daysOf': '15 из 30 дней',
  'admin.downgrade.proRataRefund': 'Пропорциональный возврат',
  'admin.downgrade.importantNote': 'Важное примечание',
  'admin.downgrade.warningDesc': 'Понижение будет выполнено немедленно. Пользователь потеряет доступ к премиум-функциям, а избыточные кредиты будут удалены.',
  'admin.downgrade.processing': 'Обработка...',
  'admin.downgrade.execute': 'Выполнить понижение',
  'admin.downgrade.notification': 'Уведомление',
  'admin.downgrade.noNotification': 'Без уведомления',
  'admin.downgrade.daysPeriod': 'дней льготного периода',
  'admin.downgrade.created': 'Создано:',
  'admin.downgrade.triggered': 'запущено',
  'admin.downgrade.noRules': 'Правила пока не созданы',
  'admin.downgrade.createFirstRule': 'Создать первое правило',
  'admin.downgrade.editRule': 'Редактировать правило',
  'admin.downgrade.createRule': 'Создать новое правило',
  'admin.downgrade.ruleName': 'Название правила',
  'admin.downgrade.description': 'Описание',
  'admin.downgrade.allConditions': 'Условия (все должны быть выполнены)',
  'admin.downgrade.addCondition': 'Добавить условие',
  'admin.downgrade.type': 'Тип',
  'admin.downgrade.value': 'Значение',
  'admin.downgrade.fromPlan': 'С тарифа',
  'admin.downgrade.toPlan': 'На тариф',
  'admin.condition.inactivity': 'Неактивность',
  'admin.condition.creditUsage': 'Использование кредитов',
  'admin.condition.loginFrequency': 'Частота входов',
  'admin.condition.featureUsage': 'Использование функций',
  'admin.condition.supportTickets': 'Заявки в поддержку',
  'admin.operator.lessThan': 'меньше чем',
  'admin.operator.greaterThan': 'больше чем',
  'admin.operator.equals': 'равно',
  'admin.operator.between': 'между',
  'admin.unit.days': 'дней',
  'admin.unit.perMonth': 'в месяц',
  'admin.unit.count': 'количество',
  'admin.transactions.all': 'Все транзакции',
  'admin.transactions.allCards': 'Все карты',
  'admin.transactions.notFound': 'Транзакции не найдены',
  'admin.transactions.totalLabel': 'Всего',
  'admin.transactions.transactions': 'транзакций',
  'admin.tips.title': 'Совет дня',
  'admin.tips.subtitle': 'Создавайте советы, отображаемые всем пользователям',
  'admin.tips.active': 'Активен',
  'admin.tips.currentlyShown': 'Этот совет сейчас отображается всем пользователям',
  'admin.tips.createNew': 'Создать новый совет',
  'admin.tips.generating': 'Генерация...',
  'admin.tips.generateAI': 'Сгенерировать совет с помощью ИИ',
  'admin.tips.titleLabel': 'Заголовок',
  'admin.tips.titlePlaceholder': 'например, Совет дня',
  'admin.tips.category': 'Категория',
  'admin.tips.categoryTip': 'Совет',
  'admin.tips.categoryFeature': 'Новая функция',
  'admin.tips.categoryProductivity': 'Продуктивность',
  'admin.tips.categoryUpdate': 'Обновление',
  'admin.tips.content': 'Содержание',
  'admin.tips.contentPlaceholder': 'Напишите ваш совет для пользователей здесь...',
  'admin.tips.addTip': 'Добавить совет',
  'admin.tips.allTips': 'Все советы',
  'admin.tips.noTips': 'Советы пока не созданы',
  'admin.tips.noTipsHint': 'Нажмите "Сгенерировать совет с помощью ИИ", чтобы начать',
  'admin.noData': 'Нет данных',
  'admin.range.7d': '7 дней',
  'admin.range.30d': '30 дней',
  'admin.range.90d': '90 дней',
  'admin.range.1y': '1 год',
  'admin.actions.saveSettings': 'Сохранить настройки',
  'admin.actions.create': 'Создать',
  'admin.downgrade.sectionReports': 'Отчёты',
  'admin.downgrade.settings': 'Настройки понижения',
  'admin.downgrade.autoApprove': 'Автоматическое одобрение',
  'admin.downgrade.autoApproveDesc': 'Автоматически одобрять запросы на понижение',
  'admin.downgrade.refundPolicy': 'Политика возврата',
  'admin.downgrade.prorata': 'Пропорциональный возврат',
  'admin.downgrade.prorataDesc': 'Пропорциональный возврат на основе оставшихся дней',
  'admin.downgrade.fullRefund': 'Полный возврат',
  'admin.downgrade.fullRefundDesc': 'Полный возврат разницы в цене',
  'admin.downgrade.noRefund': 'Без возврата',
  'admin.downgrade.noRefundDesc': 'Понижение без возврата средств',
  'admin.downgrade.daysRemaining15': '(с 15 оставшимися днями)',
  'admin.downgrade.requestsTitle': 'Запросы на понижение',
  'admin.downgrade.approvalRate': 'Коэффициент одобрения',
  'admin.downgrade.mostCommonTransition': 'Наиболее частый переход',
  'admin.downgrade.mostCommonReason': 'Наиболее частая причина',
  'admin.downgrade.avgProcessingTime': 'Ср. время обработки',
  'admin.downgrade.avgTimeDesc': 'Среднее время до принятия решения',
  'admin.downgrade.totalRefunds': 'Всего возвратов',
  'admin.downgrade.pendingRefunds': 'Ожидающих возврата',
  'admin.downgrade.summary': 'Сводка',
  'admin.downgrade.total': 'Всего',
  'admin.downgrade.csvDesc': 'Для Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'Скачать как CSV',
  'admin.downgrade.jsonDesc': 'Для разработчиков, API',
  'admin.downgrade.downloadJSON': 'Скачать как JSON',
  'admin.downgrade.exportInfo': 'Экспорт содержит',
  'admin.downgrade.entries': 'записей за выбранный период',
  'admin.downgrade.topReasons': 'Самые частые причины понижения',
  'admin.downgrade.refundHistory': 'История возвратов',
  'admin.downgrade.noRefunds': 'Возвратов пока нет',
  'admin.downgrade.statistics': 'Статистика понижений',
  'admin.downgrade.requests': 'Запросы',
  'admin.downgrade.monthlyTrend': 'Месячный тренд',
  'admin.downgrade.planTransitions': 'Переходы по тарифам',
  'admin.downgrade.trend': 'Тренд (по сравнению с пред. месяцем)',
  'admin.downgrade.trendDesc': 'Меньше понижений = лучше',
  'admin.coupons.allPlansUniversal': 'Все тарифы (Универсальный)',
  'admin.coupons.onlyStarter': 'Только Starter',
  'admin.coupons.onlyPro': 'Только Pro',
  'admin.coupons.onlyBuilder': 'Только Builder',
  'admin.coupons.allPlansHint': 'Выберите "Все тарифы" для универсального промокода',
  'admin.coupons.discountOptional': 'Скидка % (необязательно)',
  'admin.coupons.discountPlaceholder': 'например, 50 для скидки 50%',
  'admin.coupons.bonusCreditsOptional': 'Бонусные кредиты (необязательно)',
  'admin.coupons.bonusCreditsPlaceholder': 'например, 500',
  'admin.coupons.freeDurationOptional': 'Бесплатная длительность (необязательно)',
  'admin.coupons.durationPlaceholder': 'например, 30',
  'admin.coupons.freeDurationHint': 'например, 30 дней бесплатного использования',
  'admin.coupons.noLimit': 'Без ограничения использования',
  'admin.coupons.noExpiry': 'Без даты истечения',
  'admin.coupons.creditsPlaceholder': 'например, 100',
  'admin.coupons.creditsHint': 'Количество кредитов для пробного доступа',
  'admin.coupons.trialDurationHint': 'Как долго действителен пробный доступ',
  'admin.coupons.autoCalculated': 'Автоматически рассчитывается из пробной длительности',
  'admin.websiteEditor.title': 'Редактор сайта',
  'admin.websiteEditor.subtitle': 'Редактируйте все разделы главной страницы',
  'admin.websiteEditor.openPreview': 'Открыть предпросмотр',
  'admin.websiteEditor.group.structure': 'Структура страницы',
  'admin.websiteEditor.group.design': 'Дизайн и макет',
  'admin.websiteEditor.group.settings': 'Настройки',
  'admin.websiteEditor.tab.navbar': 'Навигация',
  'admin.websiteEditor.tab.howitworks': 'Как это работает',
  'admin.websiteEditor.tab.about': 'О нас',
  'admin.websiteEditor.tab.pricing': 'Цены',
  'admin.websiteEditor.tab.sections': 'Разделы',
  'admin.websiteEditor.tab.media': 'Медиа',
  'admin.websiteEditor.tab.chatwidget': 'Свяжитесь с нами',
  'admin.websiteEditor.tab.invoice': 'Счета',
  'admin.websiteEditor.tab.legal': 'Юридическая информация',
  'admin.websiteEditor.tab.seo': 'Базовое SEO',
  'admin.websiteEditor.tab.advancedseo': 'Расширенное SEO',
  'admin.websiteEditor.tab.versions': 'Версии',
  'admin.hero.title': 'Редактировать раздел Hero',
  'admin.hero.subtitle': 'Тексты, кнопки и статистика главной страницы',
  'admin.hero.reset': 'Сбросить',
  'admin.hero.save': 'Сохранить',
  'admin.hero.savedMsg': 'Данные Hero сохранены!',
  'admin.hero.badge': 'Текст бейджа',
  'admin.hero.headings': 'Заголовки',
  'admin.hero.line1White': 'Строка 1 (белая)',
  'admin.hero.line2Gold': 'Строка 2 (золотая)',
  'admin.hero.subtitleSection': 'Подзаголовок',
  'admin.hero.line1': 'Строка 1',
  'admin.hero.line2': 'Строка 2',
  'admin.hero.buttons': 'Кнопки',
  'admin.hero.primaryBtn': 'Основная кнопка (золотая)',
  'admin.hero.secondaryBtn': 'Вторичная кнопка (граница)',
  'admin.hero.stats': 'Статистика',
  'admin.hero.statN': 'Статистика {{n}}',
  'admin.hero.value': 'Значение',
  'admin.hero.label': 'Метка',
  'admin.hero.previewNote': 'Изменения станут видны на главной странице после сохранения. Перезагрузите страницу для предпросмотра.',

  // Idea History
  'history.title': 'История идей',
  'history.countLabel': '{{count}} анализов',
  'history.recentLabel': 'Ваши последние анализы',
  'history.exportAll': 'Экспортировать всё',
  'history.metrics.marketSize': 'Размер рынка',
  'history.metrics.competition': 'Конкуренция',
  'history.metrics.startingCapital': 'Стартовый капитал',
  'history.metrics.timeToMarket': 'Время до выхода',
  'history.metrics.profitPotential': 'Потенциал прибыли',
  'history.metrics.scalability': 'Масштабируемость',
  'history.summary.title': 'Резюме',
  'history.download': 'Скачать',
  'history.downloadJSON': 'Сохранить как JSON',
  'history.downloadTXT': 'Сохранить как TXT',
  'history.downloadPDF': 'Сохранить как PDF',
  'history.fullAnalysis': 'Полный анализ',
  'history.searchPlaceholder': 'Поиск по заголовку или тегам...',
  'history.filterAll': 'Все оценки',
  'history.loading': 'Загрузка анализов...',
  'history.noResults': 'Ничего не найдено',
  'history.empty': 'Анализов пока нет',
  'history.emptyHint': 'Начните анализ в ИИ-ассистенте',
  'history.delete': 'Удалить',
  'history.cancel': 'Отмена',
  'history.deleteModalTitle': 'Удалить анализ?',
  'history.deleteModalDesc': '"{{title}}" будет удалён навсегда.',
  'history.errorLoading': 'Ошибка загрузки анализов',
  'history.deleteSuccess': 'Анализ успешно удалён',
  'history.deleteError': 'Ошибка удаления анализа',
  'history.jsonExported': 'JSON экспортирован',
  'history.txtExported': 'TXT экспортирован',
  'history.allExported': '{{count}} идей экспортировано',
  'history.analysisHeader': 'АНАЛИЗ ИДЕИ',
  'history.titleLabel': 'Название',
  'history.ratingLabel': 'Оценка',
  'history.dateLabel': 'Дата',
  'history.creditsLabel': 'Кредиты',
  'history.analysisSection': 'Анализ',

  // Overview
  'overview.title': 'Обзор',
  'overview.last24h': 'Последние 24 часа',
  'overview.analysesToday': 'Анализов сегодня',
  'overview.totalAnalyses': 'Всего анализов',
  'overview.successRate': 'Успешность',
  'overview.topRatings': 'Лучшие оценки',
  'overview.recentActivity': 'Недавняя активность',
  'overview.viewAll': 'Смотреть всё',
  'overview.quickAccess': 'Быстрый доступ',
  'overview.quick.newAnalysis': 'Начать новый анализ',
  'overview.quick.newAnalysisDesc': 'Запустить новый анализ ниши с помощью ИИ',
  'overview.quick.myAnalyses': 'Мои анализы',
  'overview.quick.myAnalysesDesc': 'Просмотреть все предыдущие анализы',
  'overview.quick.buyCredits': 'Купить кредиты',
  'overview.quick.buyCreditsDesc': 'Больше кредитов для большего числа анализов',
  'overview.quick.settings': 'Настройки',
  'overview.quick.settingsDesc': 'Настроить профиль и предпочтения',
  'overview.unlimitedCredits': 'Доступны безлимитные кредиты',
  'overview.creditsAvailable': 'доступно кредитов',
  'overview.upgradePlan': 'Улучшить тариф',
  'overview.buyCredits': 'Купить кредиты',
  'overview.creditUsage': 'Использование кредитов в этом месяце',
  'overview.available': 'доступно',

  // --- Admin New Keys ---
  'admin.transactions.upgrades': 'Повышения',
  'admin.transactions.downgrades': 'Понижения',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',

  'admin.users.grantFreeSuccess': '{{name}} получил {{months}} месяц(ев) бесплатного тарифа {{plan}}',
  'admin.users.blockSuccess': '{{name}} заблокирован',
  'admin.users.unblockSuccess': '{{name}} разблокирован',
  'admin.users.removeFreeSuccess': 'Бесплатный статус {{name}} удалён',

  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Free',

  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Откройте новую функцию',
  'admin.tips.productivityBoost': 'Повышение продуктивности',
  'admin.tips.importantUpdate': 'Важное обновление',
  'admin.tips.tipOfDay': 'Совет дня',

  'admin.actions.activate': 'Активировать',
  'admin.actions.deactivate': 'Деактивировать',
  'admin.websiteEditor.tab.features': 'Функции',
  'admin.websiteEditor.tab.testimonials': 'Отзывы',
  'admin.websiteEditor.tab.faq': 'ЧаВо',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'Футер',
  'admin.websiteEditor.tab.design': 'Дизайн',
  'admin.websiteEditor.tab.customcode': 'Пользовательский код',
  'admin.websiteEditor.tab.socials': 'Социальные сети',
  'admin.websiteEditor.tab.importexport': 'Импорт/Экспорт',

  // --- AI Settings Editor ---
  'admin.ai.title': 'Настройки ИИ-ассистента',
  'admin.ai.subtitle': 'Настройте поведение, стиль и глубину анализа',
  'admin.ai.smartWeightingActive': 'Умное взвешивание активно',
  'admin.ai.smartWeightingDesc': 'ИИ автоматически объединяет все перспективы с умным взвешиванием. При наличии нескольких пресетов первый взвешивается больше (основной пресет). Вы также можете настроить взвешивание вручную.',
  'admin.ai.modelTitle': 'Модель ИИ IdeaVerdict',
  'admin.ai.modelSubtitle': 'Выберите движок ИИ для всех пользовательских анализов',
  'admin.ai.activeModel': 'Активная модель:',
  'admin.ai.activeModelDesc': 'Все пользователи получают ответы от этой модели.',
  'admin.ai.recommendations': 'Рекомендации для оптимальных результатов',
  'admin.ai.new': 'НОВОЕ',
  'admin.ai.recommendationsDesc': 'Проверенные комбинации пресетов для лучшего качества анализа',
  'admin.ai.recommendationsInfo': 'Эти комбинации были протестированы и дают наилучшие результаты. Нажмите на рекомендацию, чтобы применить её.',
  'admin.ai.active': 'АКТИВНО',
  'admin.ai.apply': 'Применить',
  'admin.ai.avoid': 'Избегайте',
  'admin.ai.excellentQuality': 'Отличное качество',
  'admin.ai.goodQuality': 'Хорошее качество',
  'admin.ai.poorQuality': 'Размытое качество - Не рекомендуется',
  'admin.ai.proTips': 'Про-советы',
  'admin.ai.tip1Title': '2 пресета оптимальны:',
  'admin.ai.tip1Desc': 'Чёткая перспектива без размытия',
  'admin.ai.tip2Title': 'Важен основной пресет:',
  'admin.ai.tip2Desc': 'Первый пресет имеет наибольшее влияние',
  'admin.ai.tip3Title': 'Избегайте противоположностей:',
  'admin.ai.tip3Desc': '"EXTREME" + "Creative" = противоречиво',
  'admin.ai.tip4Title': 'Максимум 3 пресета:',
  'admin.ai.tip4Desc': 'С 4+ пресетами результат становится слишком общим',
  'admin.ai.warningManyPresets': 'Предупреждение: Много пресетов',
  'admin.ai.warningManyPresetsDesc': 'У вас выбрано {{count}} пресетов. Это может размыть результат.',
  'admin.ai.warningRecommend': 'Рекомендуется: максимум 2-3 пресета',
  'admin.ai.forOptimalResults': 'для оптимальных результатов.',
  'admin.ai.presets': 'Пресеты',
  'admin.ai.multiSelect': '(возможен множественный выбор)',
  'admin.ai.presetsDesc': 'Выберите один или несколько пресетов. Первый пресет является основным с наивысшим весом.',
  'admin.ai.primaryPreset': 'Основной пресет',
  'admin.ai.weightControl': 'Управление весом',
  'admin.ai.weightControlDesc': 'Настройте, насколько сильно каждый пресет влияет на анализ',
  'admin.ai.manual': 'Вручную',
  'admin.ai.automatic': 'Автоматически',
  'admin.ai.autoWeightingActive': 'Автоматическое взвешивание активно:',
  'admin.ai.autoWeightingDesc': 'Вес автоматически оптимизируется в зависимости от количества пресетов.',
  'admin.ai.primary': 'ОСНОВНОЙ',
  'admin.ai.totalWeight': 'Всего',
  'admin.ai.shouldBe100': 'должно быть 100%',
  'admin.ai.normalize': 'Нормализовать',
  'admin.ai.combinedSettings': 'Объединённые настройки',
  'admin.ai.presetsCount': 'пресетов',
  'admin.ai.strictness': 'Строгость',
  'admin.ai.realism': 'Реализм',
  'admin.ai.creativity': 'Креативность',
  'admin.ai.detailLevel': 'Уровень детализации',
  'admin.ai.customInstructions': 'Пользовательские инструкции',
  'admin.ai.customInstructionsDesc': 'Дополнительные инструкции, которые объединяются с пресетами',
  'admin.ai.customInstructionsPlaceholder': 'например, "Сосредоточься на рынке DACH", "Всегда используй конкретные цифры", "Сравнивай с существующими конкурентами", "Всегда отвечай с примерами"...',
  'admin.ai.customInstructionsHint': 'Эти инструкции автоматически объединяются с выбранными пресетами.',
  'admin.ai.manualFinetuning': 'Ручная настройка',
  'admin.ai.manualFinetuningHint': '(необязательно, переопределяет значения пресетов)',
  'admin.ai.manualFinetuningDesc': 'Вручную отрегулируйте объединённые значения, если хотите что-то точно настроить.',
  'admin.ai.tone': 'Тон',
  'admin.ai.mild': 'Мягкий',
  'admin.ai.strict': 'Строгий',
  'admin.ai.creative': 'Креативный',
  'admin.ai.realistic': 'Реалистичный',
  'admin.ai.conservative': 'Консервативный',
  'admin.ai.compact': 'Компактный',
  'admin.ai.detailed': 'Детальный',
  'admin.ai.responseLength': 'Длина ответа',
  'admin.ai.short': 'Коротко и ёмко',
  'admin.ai.medium': 'Средне',
  'admin.ai.long': 'Подробно',
  'admin.ai.focusAreas': 'Области фокуса анализа',
  'admin.ai.autoRating': 'Автоматическая оценка',
  'admin.ai.autoRatingDesc': 'Каждый анализ автоматически получает оценку (Хорошо/Средне/Плохо)',
  'admin.ai.showSources': 'Показывать источники',
  'admin.ai.showSourcesDesc': 'Ссылки на источники данных и рыночные данные в ответах',
  'admin.ai.hidePreview': 'Скрыть предпросмотр',
  'admin.ai.showPreview': 'Показать предпросмотр',
  'admin.ai.aiBehavior': 'Поведение ИИ',
  'admin.ai.length': 'Длина',
  'admin.ai.liveExample': 'Живой пример',
  'admin.ai.testSettings': 'Проверьте ваши настройки',
  'admin.ai.selectExampleQuestion': 'Выберите пример вопроса:',
  'admin.ai.userAsks': 'Пользователь спрашивает:',
  'admin.ai.generating': 'ИИ генерирует ответ...',
  'admin.ai.generateExample': 'Сгенерировать пример ответа',
  'admin.ai.aiResponds': 'ИИ-ассистент отвечает:',
  'admin.ai.generateHint': 'Нажмите "Сгенерировать пример ответа", чтобы увидеть, как ИИ отвечает с вашими настройками.',
  'admin.ai.reset': 'Сбросить',
  'admin.ai.saved': 'Сохранено!',
  'admin.ai.saveSettings': 'Сохранить настройки',

  // --- Table headers ---
  'admin.coupons.code': 'Код',
  'admin.coupons.credits': 'Кредиты',

  // --- AI Model Descriptions ---
  'admin.ai.model.standardDesc': 'Сбалансированный анализ высокого качества. Лучший выбор для большинства оценок ниш и валидации идей.',
  'admin.ai.model.preciseAnalyses': 'Точные анализы',
  'admin.ai.model.bestBalance': 'Лучший баланс',
  'admin.ai.model.recommended': 'Рекомендуется',
  'admin.ai.model.fastDesc': 'Мгновенные ответы для быстрых проверок ниш, мозговых штурмов и первичных оценок. Идеально, когда важна скорость.',
  'admin.ai.model.fast': 'БЫСТРЫЙ',
  'admin.ai.model.fastestResponses': 'Самые быстрые ответы',
  'admin.ai.model.thinkingDesc': 'Глубокий анализ с расширенным логическим мышлением. Для сложных рыночных анализов, критических оценок и стратегического планирования.',
  'admin.ai.model.deepestAnalysis': 'Самый глубокий анализ',
  'admin.ai.model.logicalThinking': 'Логическое мышление',
  'admin.ai.model.strategy': 'Стратегия',

  // --- AI Preset Names & Descriptions ---
  'admin.ai.preset.strict.name': 'Строгий анализ',
  'admin.ai.preset.strict.desc': 'Критичный, основанный на фактах, без приукрашиваний. Безжалостно выявляет слабости.',
  'admin.ai.preset.extreme.name': 'ЭКСТРЕМАЛЬНЫЙ анализ',
  'admin.ai.preset.extreme.desc': 'Максимальная строгость, беспощадная критика, фокус на худшем сценарии. Только для жёсткой проверки реальности.',
  'admin.ai.preset.professional.name': 'Профессиональный',
  'admin.ai.preset.professional.desc': 'Объективный, структурированный, сбалансированный. Как опытный бизнес-консультант.',
  'admin.ai.preset.realistic.name': 'Реалистичный',
  'admin.ai.preset.realistic.desc': 'Честный и практичный. Фокус на выполнимой реализации и реальных рыночных данных.',
  'admin.ai.preset.creative.name': 'Креативный и мотивирующий',
  'admin.ai.preset.creative.desc': 'Вдохновляющий, богатый идеями, позитивный. Находит возможности и нестандартные пути.',
  'admin.ai.preset.balanced.name': 'Сбалансированный',
  'admin.ai.preset.balanced.desc': 'Хорошее сочетание критики и мотивации. Режим по умолчанию.',
  'admin.ai.preset.investor.name': 'Перспектива инвестора',
  'admin.ai.preset.investor.desc': 'Как венчурный капиталист. Фокус на масштабировании, ROI и стратегии выхода.',
  'admin.ai.preset.startup-coach.name': 'Стартап-коуч',
  'admin.ai.preset.startup-coach.desc': 'Практический наставник для основателей. Фокус на быстрой реализации и MVP.',
  'admin.ai.preset.market-researcher.name': 'Исследователь рынка',
  'admin.ai.preset.market-researcher.desc': 'Ориентированный на данные и аналитику. Глубокий рыночный и конкурентный анализ.',
  'admin.ai.preset.risk-analyst.name': 'Аналитик рисков',
  'admin.ai.preset.risk-analyst.desc': 'Фокус на рисках и наихудших сценариях. Для реалистичного планирования.',

  // --- Focus Areas ---
  'admin.ai.focus.marktanalyse': 'Анализ рынка',
  'admin.ai.focus.wettbewerb': 'Конкуренция',
  'admin.ai.focus.monetarisierung': 'Монетизация',
  'admin.ai.focus.risiken': 'Риски',
  'admin.ai.focus.finanzen': 'Финансы',
  'admin.ai.focus.skalierung': 'Масштабирование',
  'admin.ai.focus.innovation': 'Инновации',
  'admin.ai.focus.trends': 'Тренды',
  'admin.ai.focus.differenzierung': 'Дифференциация',
  'admin.ai.focus.umsetzung': 'Реализация',
  'admin.ai.focus.zielgruppe': 'Целевая аудитория',
  'admin.ai.focus.marketing': 'Маркетинг',

  // --- Tone Options ---
  'admin.ai.tone.direkt': 'Прямо и резко',
  'admin.ai.tone.professionell': 'Профессионально и объективно',
  'admin.ai.tone.ehrlich': 'Честно и практично',
  'admin.ai.tone.motivierend': 'Мотивирующе и позитивно',
  'admin.ai.tone.freundlich': 'Дружелюбно и поддерживающе',
  'admin.ai.tone.akademisch': 'Академично и аналитично',

  // --- Example Questions ---
  'admin.ai.question.niche': 'Какую прибыльную нишу вы рекомендуете?',
  'admin.ai.question.evaluate': 'Оцените мою идею: приложение для владельцев собак',
  'admin.ai.question.trends': 'Какие тренды сейчас перспективны?',
  'admin.ai.question.sharpen': 'Как я могу уточнить мою нишу?',

  'admin.ai.rec.bestCombination.title': '🏆 Лучшая комбинация (2 пресета)',
  'admin.ai.rec.bestCombination.desc': 'Критично, но конструктивно, с конкретными шагами',
  'admin.ai.rec.bestCombination.useCase': 'Рекомендуется для большинства анализов',

  'admin.ai.rec.balancedThree.title': '⚖️ Сбалансированная (3 пресета)',
  'admin.ai.rec.balancedThree.desc': 'Профессионально, реалистично и дружественно к инвесторам',
  'admin.ai.rec.balancedThree.useCase': 'Для комплексных бизнес-анализов',

  'admin.ai.rec.creativeDriven.title': '💡 Креативно и мотивирующе (2 пресета)',
  'admin.ai.rec.creativeDriven.desc': 'Вдохновляюще с практическими советами по реализации',
  'admin.ai.rec.creativeDriven.useCase': 'Для генерации идей и мозгового штурма',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Открыть меню',
  'header.home': 'Главная',
  'header.notifications': 'Уведомления',
  'header.settings': 'Настройки',
  'header.profile': 'Профиль',
  'sidebar.collapse': 'Свернуть боковую панель',
  'sidebar.expand': 'Развернуть боковую панель',
  'sidebar.close': 'Закрыть меню',
  'sidebar.plan': 'Тариф',
  'sidebar.backToWebsite': 'Вернуться на сайт',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'С возвращением',
  'overview.greetingSub': 'Вот что происходит на вашем рабочем столе вердиктов.',
  'overview.heroCta': 'Новый вердикт',
  'overview.currentPlan': 'Текущий план',
  'overview.creditsLabel': 'кредитов',
  'overview.usedThisCycle': 'Использовано в этом цикле',
  'overview.resetsOn': 'Обновится',
  'overview.unlimitedTitle': 'Безлимитно',
  'overview.builderPerk': 'У вас полный доступ Builder — без ограничений.',
  'overview.runOne': 'Запустить вердикт',
  'overview.lastVerdicts': 'Ваши последние 5 вердиктов',
  'overview.noActivity': 'Пока нет вердиктов — запустите первый анализ',
  'overview.tipTitle': 'Совет',
  'overview.tipBody': 'Прогоните идею через два языка — если вердикт смягчается, ваши предположения локальны, а не универсальны.',
  'onboard.skip': "Пропустить",
  'onboard.cta.next': "Далее",
  'onboard.cta.start': "Начать",
  'onboard.s1.title': "Добро пожаловать в IdeaVerdict",
  'onboard.s1.body': "ИИ-вердикт вашей бизнес-идее — до того, как вы начнёте строить.",
  'onboard.s2.title': "Беспощадно честные вердикты",
  'onboard.s2.body': "Без хайпа, без лести. Реальные данные рынка, реальные конкуренты, реальные риски.",
  'onboard.s3.title': "Builder Reports в PDF",
  'onboard.s3.body': "Отчёты на 25-75 страниц с полной архитектурой, финансами и стратегией выхода на рынок.",
  'onboard.s4.title': "Готовы, когда готовы вы",
  'onboard.s4.body': "Зарегистрируйтесь и получите первый вердикт менее чем за минуту.",
  'builderReport.title': "Готовим ваш Builder Report",
  'builderReport.subtitle': "Полный анализ + бриф для разработчика — скачивается как PDF.",
  'builderReport.idea': "Ваша идея",
  'builderReport.ideaPlaceholder': "Опишите вашу бизнес-идею (или оставьте пустым, чтобы взять последнюю обсуждавшуюся идею)…",
  'builderReport.cta': "Сгенерировать отчёт",
  'builderReport.credits': "кредитов",
  'builderReport.deductedNow': "Списывается при успехе",
  'builderReport.dontClose': "Пожалуйста, не закрывайте окно — генерация занимает 30-90 секунд.",
  'builderReport.done': "PDF загружен — проверьте папку загрузок.",
  'builderReport.failed': "Создание не удалось",
  'builderReport.close': "Закрыть",
  'builderReport.cancel': "Отмена",
  'builderReport.running': "Генерация…",
  'builderReport.retry': "Повторить",
  'builderReport.unknownError': "Сбой генерации. Кредиты должны быть возвращены.",
  'builderReport.signInRequired': "Чтобы сгенерировать отчёт, нужно войти в аккаунт.",
  'builderReport.ideaRequired': "Опишите идею, чтобы ИИ было что анализировать.",
  'builderReport.fromChat': "Из вашего текущего диалога",
  'builderReport.noIdeaDetected': "Используем идею, которую мы обсуждали.",
  'builderReport.contextHint': "ИИ возьмёт всё из этого чата — никакая новая идея не будет выдумана.",
  'builderReport.step.core': "Генерируем основной анализ",
  'builderReport.step.market': "Добавляем расширенный анализ рынка",
  'builderReport.step.tech': "Добавляем техническую архитектуру",
  'builderReport.step.financials': "Добавляем финансовые модели",
  'builderReport.step.compet': "Добавляем конкурентную разведку",
  'builderReport.step.gtm': "Добавляем стратегию выхода на рынок",
  'builderReport.step.deepdive': "Добавляем отраслевой разбор",
  'builderReport.step.pdf': "Собираем PDF…",
  'briefing.title': "Готовим Developer Briefing",
  'briefing.subtitle': "Технический бриф из 11 разделов — скачивается как PDF.",
  'briefing.ideaPlaceholder': "Опишите вашу бизнес-идею (или оставьте пустым, чтобы взять последнюю обсуждавшуюся идею)…",
  'briefing.cta': "Сгенерировать бриф",
  'briefing.step.core': "Готовим бриф для разработчика",
  'briefing.step.pdf': "Собираем PDF…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Больше кредитов + отчёты на 50 страниц",
  'pricing.gold.credits': "12 500 кредитов в месяц",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Максимальный тариф + отчёты на 75 страниц",
  'pricing.platinum.credits': "15 000 кредитов в месяц",
  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "ru" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Осталось всего {{count}} кредитов!",
  'trial.upgradeNow': "Обновить сейчас",
  'trial.upgradeNowArrow': "Обновить сейчас →",
  'trial.creditsExhausted': "Кредиты исчерпаны",
  'trial.upgradeForUnlimited': "Перейдите на безлимит",
  'trial.noCreditsPlaceholder': "Кредитов не осталось…",
  'hero.badgeHonest': "Честный, непредвзятый ИИ",
  'hero.badge60sec': "Вердикт за 60 секунд",
  'hero.badge20Lang': "20+ языков",
  'hero.widget.label': "Вердикт идее",
  'hero.widget.passed': "ПРОЙДЕНО",
  'hero.widget.demoIdea': "ИИ-репетитор для студентов-медиков",
  'hero.widget.market': "Рынок",
  'hero.widget.demand': "Спрос",
  'hero.widget.competition': "Конкуренция",
  'hero.widget.verdictReady': "Вердикт готов · 47 сек",
  'hero.widget.riskFlagged': "Риск зафиксирован",
  'hero.widget.crowdedMarket': "Переполненный рынок · 4 игрока",
  'hero.widget.suggestedPivot': "Предлагаемый разворот",
  'hero.widget.nicheBySpecialty': "Ниша по специальности",
  'hero.widget.feasibilityGain': "+38% реализуемости",
  'hero.widget.analysisDone': "Анализ выполнен",
  'hero.widget.metrics56': "5 из 6 метрик",
  'hero.stats.verdictSpeed': "Скорость вердикта",
  'cta.badge': "Вердикт за 60 секунд",
  'cta.subtitleEnd': "без догадок.",
  'cta.signinPrompt': "Уже есть аккаунт? Войти",
  'cta.trustTrial': "7-дневный пробный период",
  'cta.trustNoCard': "Карта не нужна",
  'cta.trustCancel': "Отмена в любой момент",
  'footer.themeLabel': "Тема:",
  'footer.lightMode': "Светлая тема",
  'footer.darkMode': "Тёмная тема",
  'footer.sectionProduct': "Продукт",
  'footer.sectionLegal': "Юридическая информация",
  'nav.switchLight': "Переключить на светлую тему",
  'nav.switchDark': "Переключить на тёмную тему",
  'features.badge': "Почему IdeaVerdict",
  'features.mainFeatureLabel': "Заголовок",
  'chatError.planRestriction': "Эта функция требует более высокий тариф.",
  'chatError.creditDeduction': "Не удалось обработать платёж. Попробуйте ещё раз.",
  'chatError.aiService': "Сервис ИИ временно недоступен. Кредиты не списаны. Попробуйте ещё раз.",
  'chatError.parseError': "Получен неожиданный формат ответа. Попробуйте ещё раз.",
  'chatError.sessionExpired': "Ваша сессия истекла. Войдите снова.",
  'chatError.timeout': "Запрос занял слишком много времени. Попробуйте ещё раз.",
  'chatError.generic': "Не удалось получить ответ. Попробуйте ещё раз.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "ru" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "Осталось всего {{count}} кредитов!",
  'trial.outOfCredits': "Кредиты исчерпаны",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Переполненный рынок · 4 игрока",
  'hero.widget.nicheBySpec': "Ниша по специальности",
  'hero.widget.feasibilityUp': "+38% реализуемости",
  'hero.widget.fiveOfSix': "5 из 6 метрик",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "Builder Report на 25 страниц",
  'pricing.gold.report': "Builder Report на 50 страниц",
  'pricing.platinum.report': "Builder Report на 75 страниц",
  'auth.bestValue': "Лучшая цена",
  'auth.elite': "Элит",
  'builderReport.friendlyError': "Нам не удалось завершить ваш отчёт. Кредиты не списаны — попробуйте ещё раз через минуту.",
  'builderReport.persistHint': "Если проблема повторяется, напишите на support@ideaverdict.ai.",
};
